<template>
  <dialog-v2
    :show="true"
    title="Estatus de la llamada"
    max-width="600px"
    @close="tryClose"
    @save="save">
    <template slot="content">
      <v-layout row wrap>
        <v-flex>
          <v-select
            v-model="form.status"
            :items="statusesList"
            item-text="status"
            item-value="status"
            v-validate="'required'"
            data-vv-name="status"
            data-vv-scope="callStatus"
            data-vv-as="estatus"
            label="Estatus"
            color="black"
            :error-messages="errors.collect('callStatus.status')"
            autocomplete/>
        </v-flex>
      </v-layout>
      <v-layout row wrap v-if="form.status === 'Sin compromiso'">
        <v-flex>
          <v-select
            v-model="form.no_payment_category"
            :items="$store.state.dialer.noPaymentCategories"
            item-text="name"
            item-value="name"
            v-validate="'required'"
            data-vv-name="noPaymentCategory"
            data-vv-scope="callStatus"
            data-vv-as="motivo de no pago"
            label="Motivo de no pago"
            color="black"
            :error-messages="errors.collect('callStatus.noPaymentCategory')"
            autocomplete/>
        </v-flex>
      </v-layout>
      <v-layout v-else-if="form.status === 'Compromiso'" row wrap>
        <v-flex>
          <v-menu
            ref="datePickerRef"
            :close-on-content-click="false"
            v-model="datePicker"
            :nudge-right="40"
            :return-value.sync="form.payment_promise"
            lazy
            transition="scale-transition"
            offset-y
            full-width
            min-width="290px">
          <v-text-field
            slot="activator"
            color="black"
            prepend-icon="event"
            label="Fecha de compromiso"
            :value="formatDate(form.payment_promise, 'YYYY-MM-DD', 'DD/MM/YYYY')"
            v-validate="'required'"
            data-vv-name="payment_promise"
            data-vv-scope="callStatus"
            data-vv-as="fecha de compromiso"
            :error-messages="errors.collect('callStatus.payment_promise')"
            readonly/>
          <v-date-picker
            v-model="form.payment_promise"
            @input="$refs.datePickerRef.save(form.payment_promise)"
            locale="es"
            :allowed-dates="allowedDates"
            color="k-orange-linear"/>
          </v-menu>
        </v-flex>
      </v-layout>
      <v-layout v-else-if="form.status === 'Intención de pago'" row wrap>
        <v-flex>
          <v-menu
            ref="datePickerRef2"
            :close-on-content-click="false"
            v-model="datePicker"
            :nudge-right="40"
            :return-value.sync="form.payment_intention"
            lazy
            transition="scale-transition"
            offset-y
            full-width
            min-width="290px">
          <v-text-field
            slot="activator"
            color="black"
            prepend-icon="event"
            label="Fecha de pago"
            :value="formatDate(form.payment_intention, 'YYYY-MM-DD', 'DD/MM/YYYY')"
            v-validate="'required'"
            data-vv-name="payment_intention"
            data-vv-scope="callStatus"
            data-vv-as="fecha de pago"
            :error-messages="errors.collect('callStatus.payment_intention')"
            readonly/>
          <v-date-picker
            v-model="form.payment_intention"
            @input="$refs.datePickerRef2.save(form.payment_intention)"
            locale="es"
            :allowed-dates="allowedDates"
            color="k-orange-linear"/>
          </v-menu>
        </v-flex>
      </v-layout>
      <v-layout v-if="form.status === 'Proximo Contacto'">
        <v-flex>
          <v-text-field
            v-model="form.next_contact"
            label="Próxima llamada"
            type="time"
            color="black"
            v-validate="'required'"
            data-vv-name="next_contact"
            data-vv-scope="callStatus"
            data-vv-as="próxima llamada"
            :error-messages="errors.collect('callStatus.payment_promise')"/>
        </v-flex>
      </v-layout>
      <v-layout row wrap>
        <v-flex>
          <v-text-field
            v-model="form.descrip"
            v-validate="'max:100'"
            data-vv-name="descrip"
            data-vv-scope="callStatus"
            data-vv-as="descripción"
            color="black"
            label="Comentario"
            :error-messages="errors.collect('callStatus.descrip')"/>
        </v-flex>
      </v-layout>
    </template>
  </dialog-v2>
</template>

<script>
import _ from 'lodash';
import moment from 'moment-timezone';
import DialogV2 from '@/components/global/DialogV2';
import formatDateMixin from '@/mixins/formatDate';
import EventBus from '@/event-bus';

export default {
  inject: ['$validator'],
  props: {
    notification: {
      type: Object,
      required: true,
    },
  },
  components: {
    DialogV2,
  },
  mixins: [
    formatDateMixin,
  ],
  data() {
    return {
      datePicker: false,
      form: {
        status: '',
        descrip: '',
        payment_promise: '',
        payment_intention: '',
        next_contact: '',
        no_payment_category: '',
      },
    };
  },
  computed: {
    statusesList() {
      return this.$store.getters.statuses.filter(item => [
        'Buzon de Voz',
        'Compromiso',
        'Desconoce deuda',
        'Entregado',
        'Equivocado',
        'Error de operador',
        'Error interno',
        'Incidencia',
        'Invalido',
        'No contesta',
        'Ocupado',
        'Pagado',
        'Proximo Contacto',
        'Recado conocido',
        'Recado familiar',
        'Rechazado',
        'Refinanciado',
        'Sin compromiso',
        'Intención de pago',
      ].includes(item.status));
    },
  },
  methods: {
    tryClose() {
      EventBus.$emit('modal', 'Debe asignar un estatus.');
    },
    allowedDates(date) {
      return moment(date, 'YYYY-MM-DD').isSameOrAfter(moment().format('YYYY-MM-DD'));
    },
    save() {
      this.$validator.validateAll('callStatus').then((validation) => {
        if (validation) {
          const timestamp = moment.utc().format('YYYY-MM-DD HH:mm:ss');
          const data = {
            ..._.omit(this.form, [
              ...this.form.status !== 'Compromiso' && [
                'payment_promise',
              ],
              ...this.form.status !== 'Proximo Contacto' && [
                'next_contact',
              ],
              ...this.form.status !== 'Intención de pago' && [
                'payment_intention',
              ],
              ...this.form.status !== 'Sin compromiso' && [
                'no_payment_category',
              ],
            ]),
            user_id: this.$auth.user().id,
          };
          if (
            data.status === 'Entregado'
            || data.status === 'Compromiso'
            || data.status === 'Rechazado'
            || data.status === 'Sin compromiso'
            || data.status === 'Proximo Contacto'
            || data.status === 'Pagado'
            || data.status === 'Refinanciado'
            || data.status === 'Desconoce deuda'
            || data.status === 'Intención de pago'
            || data.status === 'Acepta oferta'
            || data.status === 'Rechaza oferta'
            || data.status === 'Alternativa de pago'
          ) {
            data.delivered_at = timestamp;
            data.contacted_at = timestamp;
            if (data.status === 'Compromiso') {
              data.payment_promise_at = timestamp;
            } else if (data.status === 'Intención de pago') {
              data.payment_intention_at = timestamp;
            }
          } else if (data.status === 'Equivocado') {
            data.wrong_person_at = timestamp;
          } else if (data.status === 'Rechazado') {
            data.refused_at = timestamp;
          } else if (data.status === 'Buzon de Voz') {
            data.voicemail_at = timestamp;
          } else {
            data.failed_at = timestamp;
          }
          this.$emit('save', data);
        }
      });
    },
  },
  watch: {
    'form.status'() { // eslint-disable-line
      if (this.form.status !== 'Compromiso') {
        this.form.payment_promise = '';
      }
      if (this.form.status !== 'Proximo Contacto') {
        this.form.next_contact = '';
      }
      if (this.form.status !== 'Intención de pago') {
        this.form.payment_intention = '';
      }
      if (this.form.status !== 'Sin compromiso') {
        this.form.no_payment_category = '';
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/CallCenter/Status.vue